import React from 'react';
import { motion } from 'framer-motion';
import '../styles/benefits-news-cards.css';

const benefits = [
  {
    id: 'connected-ecosystem',
    img: '/static/css/assets/img/icon_4_decentralized_data_exchange.png',
    title: 'Connected AAS ecosystem',
    description:
      'Join a network of verified organizations publishing and consuming AAS data through a shared Identity, Discovery, and trust layer.',
  },
  {
    id: 'fast-onboarding',
    img: '/static/css/assets/img/icon_6_simple_onboarding.png',
    title: 'Fast onboarding',
    description:
      'Register your organization, land on the trust list, and publish AAS endpoints in one streamlined flow, no custom integration work required.',
  },
  {
    id: 'easy-to-use-tools',
    img: '/static/css/assets/img/icon_8_scalable_date_ecosystem.png',
    title: 'Easy-to-use tools',
    description:
      'Model AAS in the Editor, browse IDTA Submodel templates in the SMT Repository, and explore partners in Discovery, all from a single portal.',
  },
  {
    id: 'conformance',
    img: '/static/css/assets/img/icon_5_aas_standards_compliance.png',
    title: 'Conformance validation',
    description:
      'Validate AAS files, Submodels, and your AAS server APIs against IEC 63278 and IDTA specifications before and after deployment.',
  },
  {
    id: 'interoperability',
    img: '/static/css/assets/img/icon_7_robust_security_and_authentication.png',
    title: 'Interoperability by design',
    description:
      'Providers and consumers work together through shared IDTA Submodel templates and a common AAS API, so systems integrate without bespoke connectors.',
  },
  {
    id: 'sovereign-exchange',
    img: '/static/css/assets/img/icon_9_transparent_date_exchange.png',
    title: 'Sovereign data exchange',
    description:
      'AAS data flows directly between provider and consumer. ADX Hub stays out of the data path, so ownership and control stay with you.',
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Benefits() {
  return (
    <section
      id="benefits"
      className="benefits-news bg-white py-16 md:py-20"
      data-testid="benefits-section"
    >
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.4 }}
          className="mx-auto max-w-2xl text-center"
        >
          <h2 className="text-3xl font-bold tracking-tight text-[#0028CD] md:text-4xl">
            Benefits
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-slate-500">
            Join the ecosystem, model and validate your AAS, and exchange data
            directly with verified partners.
          </p>
        </motion.div>

        <div className="content-wrapper mt-12">
          {benefits.map((benefit, index) => (
            <motion.article
              key={benefit.id}
              custom={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.15 }}
              variants={cardVariants}
              data-testid={`benefit-${benefit.title.toLowerCase().replace(/\s+/g, '-')}`}
              className="news-card"
            >
              <div className="news-card__icon-wrap">
                <span
                  className="news-card__image"
                  style={{ '--icon-url': `url(${benefit.img})` }}
                  aria-hidden="true"
                />
              </div>
              <div className="news-card__text-wrapper">
                <h3 className="news-card__title">{benefit.title}</h3>
                <div className="news-card__details-wrapper">
                  <p className="news-card__excerpt">{benefit.description}</p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
